import React, { useState } from 'react'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import CustomImage from '../../customImage/customImage'
import useTemplateHook from '../templateHook'
import EditMenu from '../editMenu'
import AddSection from '../addSection'
import { withTheme } from 'theming'
import PassimPlayer from '../rosemary/passimPlayer'
import { isEmpty } from 'lodash'

const InteriorSquare = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const { data, id } = componentData
  const [hoverState, setHoverState] = useState('')
  const [centerIndex, setCenterIndex] = useState(0)
  const { customNavigate, getTemplateImage, BannerPlaceholder, isBrowser } = useTemplateHook()

  console.log('isBRowser', isBrowser)

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleClick = (index) => {
    let linkObj = data?.slide_data[index]?.link
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const handleCarouselChange = (index) => {
    setCenterIndex(index)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <>
      <div
        style={{
          height: '25px',
        }}
        className={`hidden xl:block w-full`}
      >{`.`}</div>
      <div
        style={{
          backgroundColor: `${getStyleValue('component_background', 'primary_color', theme.c1)}`,
        }}
        className={`${isEdit && hoverState && 'component-hover-class'} relative h-full`}
        onMouseOver={() => handleHoverItems(`TOP`)}
        onMouseLeave={() => handleHoverItems('')}
      >
        {isEdit && hoverState.length > 0 && (
          <EditMenu
            onDelete={() => onDelete(id)}
            onCopy={() => onCopy(id)}
            onMoveUp={() => onSwap(id, 'up')}
            onMoveDown={() => onSwap(id, 'down')}
            onEdit={() => handleModal()}
          />
        )}
        <Carousel
          showThumbs={false}
          showStatus={false}
          centerMode={isBrowser}
          centerSlidePercentage={70}
          showArrows={isBrowser}
          infiniteLoop={true}
          autoPlay={data?.auto_slide}
          autoFocus={true}
          useKeyboardArrows={true}
          emulateTouch={true}
          onClickItem={handleClick}
          onChange={handleCarouselChange}
        >
          {data?.slide_data.map((slide, index) => (
            <div
              key={index}
              className={
                'items-center bg-black  justify-center flex relative md:mx-8 overflow-hidden'
              }
              style={{ borderRadius: '10px' }}
            >
              {isEdit || !slide?.player?.type ? (
                <CustomImage
                  imageUrl={getTemplateImage(slide?.image_s3_key)}
                  errorPlaceholder={BannerPlaceholder}
                  imgClass="w-full object-cover"
                  loaderClass=""
                  loaderStyle={{ height: '40vw' }}
                  imgAlt={index}
                />
              ) : (
                <div
                  className=" w-full h-full overflow-hidden"
                  style={{ borderRadius: '0.62rem', aspectRatio: '1.77' }}
                >
                  <PassimPlayer
                    data={slide?.player}
                    poster={getTemplateImage(slide?.image_s3key)}
                    controlBar={false}
                  />
                </div>
              )}

              {centerIndex === index && (
                <div
                  style={{
                    backgroundImage: `linear-gradient(91deg,${getStyleValue(
                      'overlay_background',
                      'color',
                      '',
                    )}00 1%,${getStyleValue(
                      'overlay_background',
                      'color',
                      '',
                    )}80 40%,${getStyleValue('overlay_background', 'color', '')} 89%`,
                  }}
                  className="absolute right-0 text-right w-1/2 xl:w-2/5 2xl:w-[38%] px-[8px] md:px-[16px] xl:px-[2.5vw] h-full flex items-center justify-end"
                >
                  <div className=" w-full xl:w-[72%]">
                    <p
                      style={{
                        color: getStyleValue('heading', 'color', '#fff'),
                        fontFamily: getStyleValue('heading', 'font', ''),
                        textAlign: getStyleValue('heading', 'alignment', ''),
                      }}
                      className={`text-[12px] md:text-xl mb-[16px] ${getStyleValue(
                        'heading',
                        'font_format',
                        'font-bold',
                      )} xl:w-`}
                    >
                      {slide?.heading}
                    </p>

                    <p
                      style={{
                        color: getStyleValue('sub_heading', 'color', '#bcbcbc'),
                        fontFamily: getStyleValue('sub_heading', 'font', ''),
                        textAlign: getStyleValue('sub_heading', 'alignment', ''),
                        display: '-webkit-box',
                        WebkitLineClamp: 4,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                      className={`text-[10px] md:text-sm mb-[16px] ${getStyleValue(
                        'sub_heading',
                        'font_format',
                        '',
                      )}`}
                    >
                      {slide?.sub_heading}
                    </p>

                    <div className="hidden lg:block">
                      <p
                        style={{
                          color: getStyleValue('field1', 'color', '#fff'),
                          fontFamily: getStyleValue('field1', 'font', ''),
                          textAlign: getStyleValue('field1', 'alignment', ''),
                        }}
                        className={`text-sm mb-[16px] font-semibold ${getStyleValue(
                          'field1',
                          'font_format',
                          'font-bold',
                        )}`}
                      >
                        {slide?.field1?.heading}
                      </p>

                      <p
                        style={{
                          color: getStyleValue('field2_heading', 'color', '#fff'),
                          fontFamily: getStyleValue('field2_heading', 'font', ''),
                          textAlign: getStyleValue('field2_heading', 'alignment', ''),
                        }}
                        className={`text-sm font-semibold mb-0 ${getStyleValue(
                          'field2_heading',
                          'font_format',
                          '',
                        )}`}
                      >
                        {slide?.field2?.heading}
                      </p>

                      <p
                        style={{
                          color: getStyleValue('field2_value', 'color', '#bcbcbc'),
                          fontFamily: getStyleValue('field2_value', 'font', ''),
                          textAlign: getStyleValue('field2_value', 'alignment', ''),
                        }}
                        className={`text-sm mb-[16px] ${getStyleValue(
                          'field2_value',
                          'font_format',
                          '',
                        )}`}
                      >
                        {slide?.field2?.value}
                      </p>

                      <p
                        style={{
                          color: getStyleValue('field3_heading', 'color', '#fff'),
                          fontFamily: getStyleValue('field3_heading', 'font', ''),
                          textAlign: getStyleValue('field3_heading', 'alignment', ''),
                        }}
                        className={`text-sm font-semibold mb-0 ${getStyleValue(
                          'field3_heading',
                          'font_format',
                          '',
                        )}`}
                      >
                        {slide?.field3?.heading}
                      </p>

                      <p
                        style={{
                          color: getStyleValue('field3_value', 'color', '#bcbcbc'),
                          fontFamily: getStyleValue('field3_value', 'font', ''),
                          textAlign: getStyleValue('field3_value', 'alignment', ''),
                        }}
                        className={`text-sm ${getStyleValue('field3_value', 'font_format', '')}`}
                      >
                        {slide?.field3?.value}
                      </p>
                    </div>

                    {slide?.cta_button?.enabled && slide.cta_button.text && (
                      <button
                        className="text-[12px] px-[16px] py-[8px] md:mt-[32px] xl:mt-[5.5vw] md:py-[8px] md:px-[24px] sm:text-sm self-end"
                        style={{
                          backgroundImage: `linear-gradient(to ${getStyleValue(
                            'button',
                            'gradient',
                            'left',
                          )}, ${getStyleValue(
                            'button',
                            'primary_color',
                            theme.c2,
                          )}, ${getStyleValue('button', 'secondary_color', theme.c2)})`,
                          color: getStyleValue('button', 'text_color', '#fff'),
                          borderRadius: '6px',
                          border: 'none',
                        }}
                      >
                        {slide.cta_button.text}
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </Carousel>
        {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
      </div>
    </>
  )
}

export default withTheme(InteriorSquare)
